import { Module } from 'vuex';
import { GlobalState } from '../types';
import { SessionsState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: SessionsState = {
    sessions: [],
    recents: [],
    timer: null,
    pulling: false,
    destination: null,
    firstPull: true
};

const namespaced: boolean = true;
export const sessions: Module<SessionsState, GlobalState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
